export const PHONE_PREFIXES = [
  { code: "+58", flag: "🇻🇪", country: "Venezuela" },
  { code: "+57", flag: "🇨🇴", country: "Colombia" },
  { code: "+34", flag: "🇪🇸", country: "España" },
  { code: "+56", flag: "🇨🇱", country: "Chile" },
  { code: "+1", flag: "🇺🇸", country: "EEUU/Canadá" },
];

export const DEFAULT_PHONE_PREFIX = "+58";

// Prefijo de un número internacional ("+58412..." -> "+58"), o el default si no coincide ninguno
export const getPhonePrefix = (phone?: string) =>
  PHONE_PREFIXES.find(prefix => phone?.startsWith(prefix.code))?.code ?? DEFAULT_PHONE_PREFIX;
